<template>
  <div>
    <div v-if="motion">
      <motion-view :motion="motion" :show-speaker-state="true"/>
    </div>
    <div v-else>
      -
    </div>
  </div>
</template>

<script>
import MotionView from './MotionView.vue'

export default {
  name: 'CurrentMotion',
  components: {
    MotionView
  },
  async created () {
    await this.$store.dispatch('motions/loadCurrent')
  },
  computed: {
    motion () {
      return this.$store.getters['motions/current']
    }
  },
  methods: {
    async load () {
      await this.$store.dispatch('motions/loadCurrent')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/motions/CurrentMotion.vue